export default "__VITE_ASSET__jcCqNkJB__"